import { fetchAllCampaignTemplates } from '@store/actions'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { useEffect } from 'react'

interface MarketingTemplateHooks {
  showPreview: boolean
}

const useMarketingTemplate = (): MarketingTemplateHooks => {
  const dispatch = useAppDispatch()
  const clinic = useAppSelector((state) => state.clinic.selectedClinic)
  const showPreview = useAppSelector(
    (state) => state.marketing.showTemplatePreview,
  )

  useEffect(() => {
    if (clinic) {
      dispatch(fetchAllCampaignTemplates())
    }
  }, [dispatch, clinic])

  return {
    showPreview,
  }
}

export default useMarketingTemplate
